module.exports = __webpack_public_path__ + "static/media/6.83632940.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/400/6.png
// module id = 1167
// module chunks = 0